import React from "react";
import styled from "styled-components";
import TopBanner from "../../Sections/TopBanner/NewTopBanner";
import XploreChart from "../../Sections/XploreChart";
import SmartBenefits from "../../Sections/SmartBenefits";
import newBanner from "../../images/globemb.png";
import mobileBanner from "../../images/globemb.png";
import { FaCheck, FaTimes } from "react-icons/fa";
import { breakpoints } from "../../utils/breakpoints";
import logo from "../../images/2025largeL.png";
import { useOutletContext } from "react-router-dom";

const StyledDiv = styled.div`
	overflow-x: hidden;
	background: #0A0B0D 0% 0% no-repeat padding-box;
	color: white;
	.spanTravel {
		padding: 15px;
		text-align: left;
		font-size: 18px;
		margin-left: 20px;
		width: 90%;
		margin: auto;
		line-height: 2;
	}

	.smartflogo{
		width: 40%;
	}

	
		.notified p{
			font-size: 15px;
			margin-bottom: 7px;
		}


	.content-container {
		padding: 100px 0;
		font: normal normal normal 1.5vw/3vw Nexa-light;
		border-top: 1px solid rgba(254, 254, 254, 0.20);

		.imagetop{
		width: 40%;
		}

		.heading {
			padding-bottom: 50px;
			background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
			font-family: "nexa-bold";
			background-clip: text;
			font-weight: 900;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-weight: normal;
		}

		table {
			width: 90%;
			margin: auto;
			border-collapse: collapse;
			margin-top: 50px;
			border-radius-top-left: 8px;
			
			
			border-radius: 4px;

			.col-1 {
				text-align: left;
				width: 50%;
			}

			.x {
				opacity: 0.25;
			}

			th {
				padding: 25px;
				font-family: 'nexa-bold';
			}

			td {
				font: normal normal normal 1.5vw/3vw Nexa-light;
				padding: 10px 25px;

				.sm-txt {
					font-size: 1vw;
				}
			}

			tr {
				border-bottom: 2px solid rgba(254, 254, 254, 0.10);
				border-right: 2px solid rgba(254, 254, 254, 0.10);
				border-left:  2px solid rgba(254, 254, 254, 0.10);

				&:nth-child(odd) {
					
				}

				&:hover {
				
				}
			}

			.elite{
			background: rgba(68, 178, 221, 0.60);
			}

			.elite2{
			color: #44B2DD;
			background: rgba(68, 178, 221, 0.20);
			}
		}

		.TravelProHeader {
			background-color: rgba(254, 254, 254, 0.10);
		}
	}

	@media screen and ${breakpoints.device.mobileL} {
	
		.notified p{
			font-size: 13px;
		}

		.spanTravel {
			font-size: 2.5vw;
		}
		.content-container {
			font-size: 3vw;
			padding: 50px 0;

				.imagetop,
				.smartflogo {
		width: 75%;
		}

			.heading{
			padding-top:  15px;
			}

			table {
				td,
				th {
					padding: 10px;
				}

				td {
					font-size: 2.5vw;

					.sm-txt {
						font-size: 2vw;
					}
				}
			}
		}
	}
`;

const MemberBenefits = () => {

	const { setIsSubModalOpen } = useOutletContext();
	return (
		<StyledDiv>
			<TopBanner
				bg={
					window.innerWidth < 750
						? mobileBanner
						: newBanner
				}
				title={
						<>
						Member Benefits
						</>
					}
				txt={
					<>
						<b>iGenius helps people </b>
						solve their problems in new and
						brilliant ways.
					</>
				}
			/>
			<div className="content-container">
				<div data-aos="fade-down">
					<img src={logo} className="imagetop"/>
				</div>
				<table>
					<tbody>
						<tr className="header TravelProHeader">
							<th className="col-1">
								Core Benefits
							</th>
							<th>Choice</th>
							<th>Select</th>
							<th>Premium</th>
							<th className="elite">
								Elite
							</th>
						</tr>
						<tr>
							<td className="col-1">
								One-Time Fee
							</td>
							<td>$99.99</td>
							<td>$299.99</td>
							<td>$599.99</td>
							<td className="elite2">
								$1,499.99
							</td>
						</tr>
						<tr>
							<td className="col-1">
								Monthly Renewal
								Fee
							</td>
							<td>$99.99</td>
							<td>$174.99</td>
							<td>$174.99</td>
							<td className="elite2">
								$174.99
							</td>
						</tr>
						<tr>
							<td className="col-1">
								University
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						<tr>
							<td className="col-1">
								learnLIVE
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						<tr>
							<td className="col-1">
								MONEYpro
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						<tr>
							<td className="col-1">
								MARKETpro
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						<tr>
							<td className="col-1">
								FOREXthrive{" "}
								<span className="sm-txt">
									(FX Delta, FX Essentials, and More!)
								</span>
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						
						<tr>
							<td className="col-1">
								CRYPTOcore{" "}
								<span className="sm-txt">
									(Crypto Talk,
									Crypto Surge, and More!)
								</span>
							</td>
							<td >
								
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>

						<tr>
							<td className="col-1">
								TRADEhub{" "}
								
							</td>
							<td >
								
							</td>
							<td>
								<FaCheck />
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						
						<tr>
							<td className="col-1">
								EQUITYprime{" "}
								<span className="sm-txt">
									(Trend Pro,
									Options Pro
									and
									More!)
								</span>
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>

						<tr>
							<td className="col-1">
								SCANpro{" "}								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td>
								<FaCheck />
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						
						<tr>
							<td className="col-1">
								ALPHAtrader{" "}
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
					
						<tr>
							<td className="col-1">
								ELITE Advantage
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						<tr>
							<td className="col-1">
								CRYPTOelite
								powered by
								Endotech
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>

						<tr>
							<td className="col-1">
								COINpro / Cforce Strategy <span className="sm-txt">(Technology by 3Commas)</span>
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						
						<tr>
							<td className="col-1">
								Elite Exclusive Channels <span className="sm-txt">(Crypto Flow and Oil Pro)</span>
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						<tr>
							<td className="col-1">
								Discounts on Various Products and Services
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						<tr>
							<td className="col-1">
								Elite Advantage
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="x">
								
							</td>
							<td className="elite2">
								<FaCheck />
							</td>
						</tr>
						
					</tbody>
				</table>
				<br />
				<div style={{textAlign: 'center'}} className="notified">
					{window.innerWidth > 750 ? <p>CRYPTOelite is not available to residents of Canada, Belgium, or Austria. COINpro/Cforce is not available to residents of Canada.</p>	: 
					<><p>CRYPTOelite is not available to residents of Canada, Belgium, or Austria.</p> <p>COINpro/Cforce is not available to residents of Canada.</p></>
					}
									
				</div>
				<div style={{textAlign: 'center'}}>
					<button
								onClick={() => {
									setIsSubModalOpen(
										true
									);
								}}
								className="section-btn">
								Get Started
							</button>
				</div>
				<p className="spanTravel">
					
				</p>
				<br />
				<br />
				<XploreChart />
				<br />
				<br />
				<SmartBenefits />
			</div>
		</StyledDiv>
	);
};

export default MemberBenefits;
